<template>
  <div class="add-project-npa">
    <v-btn class="btn-add-category" @click.native.stop="npaDialog = true">
      <span class="pro-icon-add"></span>{{ $t("Выбрать проект НПА") }}
    </v-btn>
    <v-dialog v-model="npaDialog" max-width="560">
      <v-card class="modal modal-project-npa-law">
        <div class="modal-head">
          {{ $t('Форма добавления проекта НПА к Закону') }}
          <v-btn color="modal-close" @click.native="npaDialog = false">
            <span class="pro-icon-close1"></span>
          </v-btn>
        </div>
        <div
          class="modal-body"
        >
          <div class="form-group">
            <h5>{{ $t( "Добавить проект НПА из базы проектов НПА") }}</h5>
            <v-autocomplete
              v-model="npaId"
              :loading="loading"
              :items="items"
              :search-input.sync="search"
              cache-items
              item-text="transName"
              item-value="id"
              required
              outlined
              dense
              clearable
              :placeholder="$t('Введите название для поиска')"
            />
          </div>
          <div class="adding-db-npa">
            <div class="form-group form-action">
              <button
                class="btn btn-default blue"
                @click.prevent="addNpaProject()"
              >
                {{ $t("Сохранить") }}
              </button>
              <button
                class="btn btn-default white"
                @click.prevent="npaDialog = false"
              >
                {{ $t("Отмена") }}
              </button>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import LAW from '@/model/law'

  export default {
    props: {
      npas: Array,
      lawProjectId: Number
    },
    data: () => ({
      npaDialog: false,
      npaId: null,
      loading: false,
      items: [],
      search: null,
    }),
    watch: {
      search (val) {
        val && val !== this.npaId && this.querySelections(val)
      },
    },
    methods: {
      addNpaProject() {
        LAW.addNpaToLawProject(this.lawProjectId, this.npaId).then((response) => {
          if (response.status === 200) {
            this.npaDialog = false
            this.$parent.fetchData(false)
          }
        }).catch((error) => {
          console.log(error)
        })
      },
      querySelections (v) {
        this.loading = true
        setTimeout(() => {
          this.items = this.npas
          this.loading = false
        }, 500)
      },
    }
  }
</script>
